import React, { type PropsWithChildren, useCallback } from 'react';

import { STATSIG_FULL_PAGE_SEARCH_LAYER } from '@atlassian/search-experiment/constants';
import { SEARCH_USE_CASE_IDS } from '@atlassian/search-common/search-use-case-id';

import { SearchExperience } from '../../../common/constants/search-experience';
import { ErrorComponent, type ErrorComponentProps } from '../../../common/ui/error';
import { AdvancedSearchViewed } from '../../../controllers/analytics/advanced-search-viewed';
import { ErrorBoundary } from '../../../controllers/error-boundary';
import { FetchJsmIncidentFilterIds } from '../../../controllers/fetch-jsm-incident-filter-ids';
import { RemoveReferrer } from '../../../controllers/remove-referrer';
import { SpotlightPrefetch } from '../../../controllers/spotlight';
import {
	type BootstrapContainerProps,
	BootstrapStoreProvider as BootstrapProvider,
} from '../../../controllers/store/bootstrap/bootstrap-store-provider';
import { SearchStoreProvider } from '../../../controllers/store/search/search-store-provider';

type BoostrapProps = PropsWithChildren<BootstrapContainerProps>;

export const Bootstrap = ({ children, ...props }: BoostrapProps): React.JSX.Element => {
	const renderWithErrorInfo = useCallback(
		(props: ErrorComponentProps) => <ErrorComponent {...props} />,
		[],
	);
	return (
		<ErrorBoundary renderWithErrorInfo={renderWithErrorInfo} section="SearchPageRelayBootstrap">
			<BootstrapProvider
				{...props}
				statsigLayer={STATSIG_FULL_PAGE_SEARCH_LAYER}
				experience={SearchExperience.SEARCH_PAGE}
			>
				<SearchStoreProvider
					experience={SearchExperience.SEARCH_PAGE}
					useCaseId={SEARCH_USE_CASE_IDS.SEARCH_PAGE}
				>
					<AdvancedSearchViewed />
					<RemoveReferrer />
					<SpotlightPrefetch />
					<FetchJsmIncidentFilterIds />
					{children}
				</SearchStoreProvider>
			</BootstrapProvider>
		</ErrorBoundary>
	);
};
